import { FC } from "react";
import Heading from "components/Heading/Heading";

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

const FOUNDER_DEMO: Statistic[] = [
  {
    id: "1",
    heading: "20+",
    subHeading: "events",
  },
  {
    id: "2",
    heading: "15+ ",
    subHeading: "organizations",
  },
  {
    id: "3",
    heading: "160+",
    subHeading: "participants ",
  },
];

export interface SectionStatisticProps {
  className?: string;
}

const SectionStatistic: FC<SectionStatisticProps> = ({ className = "" }) => {
  return (
    <div className={`nc-SectionStatistic relative ${className}`}>
      <Heading desc=" ">The DIS Festival in numbers</Heading>
      <div className="grid md:grid-cols-2 gap-6 lg:grid-cols-3 xl:gap-8">
        {FOUNDER_DEMO.map((item) => (
          <div
            key={item.id}
            className="p-6 bg-neutral-50 dark:bg-neutral-800 rounded-2xl dark:border-neutral-800"
          >
            <h3 className="text-6xl font-semibold leading-none text-neutral-900 md:text-6xl dark:text-neutral-200">
              {item.heading}
            </h3>
            <span
              className="block text-xl
             text-neutral-500 mt-3 dark:text-neutral-400"
            >
              {item.subHeading}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionStatistic;
